import {
  SET_LABELLING_FLOW_DATA,
  SET_TOOL_CONTEXT_MENU_DATA,
  RESET_LABELLING_AND_CONTEXT_MENU,
  SET_IMAGE_CONTEXT_DATA,
  RESET_IMAGE_CONTEXT_DATA,
  SET_HEATMAP_CONTEXT_DATA,
} from './actionTypes';

export const setLabellingFlowDataAction = labellingFlowData => ({
  type: SET_LABELLING_FLOW_DATA,
  labellingFlowData,
});

export const resetLabellingAndContextMenuAction = () => ({
  type: RESET_LABELLING_AND_CONTEXT_MENU,
});

export const setToolContextMenuDataAction = (
  viewportIndex,
  toolContextMenuData
) => ({
  type: SET_TOOL_CONTEXT_MENU_DATA,
  viewportIndex,
  toolContextMenuData,
});

export const setImageContextDataAction = (viewportIndex, eventData) => ({
  type: SET_IMAGE_CONTEXT_DATA,
  viewportIndex,
  eventData,
});

export const resetImageContextDataAction = () => ({
  type: RESET_IMAGE_CONTEXT_DATA,
});

export const setHeatmapContextData = data => ({
  type: SET_HEATMAP_CONTEXT_DATA,
  data,
});
